export enum FormIds {
  REGISTRATION = 'registration',
  SIGN_IN = 'sign-in',
  SIGN_UP = 'sign-up',
  UPDATE_PASSWORD = 'update-password',
  RETAILER_REGISTRATION = 'retailer-registration',
  BRAND_REGISTRATION = 'brand-registration',
  DISTRIBUTOR_REGISTRATION = 'distributor-registration',
  USER_DATA = 'user-data',
}
